import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckPriceOrder } from 'app/models/order/check-price-order/check-price-order';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';
import { ORDERS } from '../base/service-const';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends AbstractHttpService<any> {

  enabledButton: boolean = true;

  constructor(
    protected _httpClient: HttpClient,
    private appConfigService: AppConfigService
  ) {
    super(_httpClient, ORDERS, appConfigService.apiBaseUrl);
  }

  public findAll(page?: number): Observable<any> {
    return this.customList(`page/${page ?? 1}`);
  }

  public sendOrder(): Observable<any> {
    return this.create(null, '/orders/carts');
  }

  public checkPricesByOrderId(orderId: number): Observable<any> {
    return this.customRead(`checkPrices/${orderId}`).pipe(take(1));
  }

  public checkPricesByItem(orderToCheck: CheckPriceOrder): Observable<any> {
    return this.create(orderToCheck, '/checkPrices').pipe(take(1));
  }
}
